var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { MathUtils } from 'three';
import { CURATOR_URL } from '../api/urls';
export default class Oauth {
    constructor() {
        this.disposeCalls = [];
        this.button = document.getElementById('oauth-button');
        this.button.classList.remove('is-hidden');
        {
            const onClick = () => this.click();
            this.button.addEventListener('click', onClick);
            this.disposeCalls.push(() => this.button.removeEventListener('click', onClick));
        }
        this.checkStatus();
    }
    checkStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            const sessionUuid = this.getCookie('session_uuid');
            if (sessionUuid) {
                const url = `${CURATOR_URL}/oauth/receive_token`;
                const result = yield fetch(url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        session_uuid: sessionUuid
                    })
                });
                const json = yield result.json();
                const accessToken = json.access_token;
                if (accessToken !== undefined) {
                    const expiration = new Date();
                    expiration.setHours(expiration.getHours() + 96); // TODO: sync with the JWT expiration time
                    this.setCookie('access_token', json.access_token, expiration);
                    this.deleteCookie('session_uuid');
                }
            }
            const accessToken = this.getCookie('access_token');
            if (accessToken) {
                const url = `${CURATOR_URL}/oauth/info`;
                const result = yield fetch(url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
                    body: JSON.stringify({
                        access_token: accessToken
                    })
                });
                this.userInfo = yield result.json();
            }
        });
    }
    signOut() {
        this.userInfo = undefined;
        this.deleteCookie('access_token');
        this.hideUserInfo();
    }
    click() {
        if (this.userInfo === undefined)
            this.redirectToSignIn();
        else
            this.showUserInfo();
    }
    redirectToSignIn() {
        const uuid = MathUtils.generateUUID();
        {
            const expiration = new Date();
            expiration.setHours(expiration.getHours() + 1);
            this.setCookie('session_uuid', uuid, expiration);
        }
        const redirect = window.location.href;
        const url = new URL('https://auth.dev-v2.spheresdev.co.uk/oauth'); // TODO: put in an .env
        url.searchParams.set('redirect_uri', btoa(redirect));
        url.searchParams.set('session_uuid', uuid);
        window.location.href = url.toString();
    }
    showUserInfo() {
        if (this.popup) {
            this.hideUserInfo();
            return;
        }
        const popup = document.createElement('div');
        popup.className = 'oauth-popup';
        if (this.userInfo.email !== undefined) {
            const email = document.createElement('div');
            email.className = 'oauth-popup-email';
            email.textContent = this.userInfo.email;
            popup.appendChild(email);
        }
        {
            const provider = document.createElement('div');
            provider.className = 'oauth-popup-provider';
            provider.textContent = this.userInfo.provider;
            popup.appendChild(provider);
        }
        {
            const logOut = document.createElement('button');
            logOut.className = 'oauth-popup-log-out';
            logOut.textContent = 'Log out';
            logOut.onclick = () => this.signOut();
            popup.appendChild(logOut);
        }
        {
            const rect = this.button.getBoundingClientRect();
            popup.style.position = 'fixed';
            popup.style.top = `${rect.bottom}px`;
            popup.style.right = `${window.innerWidth - rect.right}px`;
        }
        document.body.appendChild(popup);
        this.popup = popup;
        const onOutsideClick = (e) => {
            const target = e.target;
            if (!popup.contains(target) && !this.button.contains(target))
                this.hideUserInfo();
        };
        document.addEventListener('click', onOutsideClick, true);
        this.closePopup = () => document.removeEventListener('click', onOutsideClick, true);
    }
    hideUserInfo() {
        var _a, _b;
        (_a = this.closePopup) === null || _a === void 0 ? void 0 : _a.call(this);
        this.closePopup = undefined;
        (_b = this.popup) === null || _b === void 0 ? void 0 : _b.remove();
        this.popup = undefined;
    }
    // TODO: move cookie methods to a util file, use CookieStore if available
    getCookie(name) {
        var _a;
        return (_a = document.cookie
            .split('; ')
            .find(row => row.startsWith(`${name}=`))) === null || _a === void 0 ? void 0 : _a.split('=')[1];
    }
    setCookie(name, value, expiration) {
        const expires = 'expires=' + expiration.toUTCString();
        document.cookie = `${name}=${value};${expires};path=/`;
    }
    deleteCookie(name) {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
    dispose() {
        this.hideUserInfo();
        this.disposeCalls.forEach(it => it());
    }
}
